import { Shield } from 'lucide-react';
import { useTranslation } from '@/i18n/TranslationContext';

export function AppFooter() {
  const { t } = useTranslation();
  return (
    <footer className="border-t border-border/30 py-4 px-6 mt-auto" data-testid="app-footer">
      <div className="max-w-[1440px] mx-auto flex flex-col sm:flex-row items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <Shield className="h-3 w-3 text-primary" />
          <span className="text-[10px] text-muted-foreground">{t('powered_by')} {"\u2014"} {t('cybercheck_product')}</span>
        </div>
        <div className="flex items-center gap-4 text-[10px] text-muted-foreground">
          <a href="#" className="hover:text-foreground transition-colors">{t('privacy_policy')}</a>
          <a href="#" className="hover:text-foreground transition-colors">{t('terms_of_service')}</a>
          <a href="https://www.cybercheck.one" target="_blank" rel="noopener noreferrer" className="hover:text-foreground transition-colors">{t('contact')}</a>
        </div>
      </div>
    </footer>
  );
}
